import Button from 'components/Button';
import useScreenSize from 'hooks/useScreenSize';
import Close from 'icons/Close';
import { usePhotoGalleryContainer } from '..';
import PhotoGalleryActions from './PhotoGalleryActions';
import styles from './styles/PhotoGalleryModalControls.module.scss';
import Link, { BackParam } from 'components/Link';

export default function PhotoGalleryModalControls() {
  const [{ photoGallery, currentIndex, photoSlides, slideAdIndex }, { isPhoto }] = usePhotoGalleryContainer();
  const { isSmallScreen } = useScreenSize();

  return (
    <>
      <div className={styles.ModalControls}>
        <Link href={photoGallery.webPath} back={BackParam.PERSIST}>
          <Button
            label={
              <>
                <Close color="#FFFFFF" height={11} width={11} className={styles.Icon} /> Close
              </>
            }
            type="WhiteOnBlack"
            className={styles.CloseButton}
          />
        </Link>
        <PhotoGalleryActions buttonType="WhiteOnBlack" iconColor="#FFFFFF" />
      </div>
      {isSmallScreen && isPhoto(photoSlides[currentIndex]) && (
        <div
          className={styles.Counter}
        >{`${currentIndex < slideAdIndex ? currentIndex + 1 : currentIndex} / ${photoGallery.photos.length}`}</div>
      )}
    </>
  );
}
